import { register } from 'tmr/tmr/ngModuleRegistry'

import * as appData from './appData/appData'
import * as appDataForm from './appData/form'
import * as configurationForm from './configurations/form'
import * as configurations from './configurations/configurations'
import * as itemConfigurations from './itemConfigurations/itemConfigurations'
import * as itemConfigurationsForm from './itemConfigurations/form'
import * as operationConfigurationForm from './operationConfigurations/form'
import * as operationConfigurationFormAttributeRow from './operationConfigurations/attributeRow'
import * as operationConfigurations from './operationConfigurations/operationConfigurations'

export default register(
  'tmr.core.routes.admin.settings',
  appData,
  appDataForm,
  configurationForm,
  configurations,
  itemConfigurations,
  itemConfigurationsForm,
  operationConfigurationForm,
  operationConfigurationFormAttributeRow,
  operationConfigurations
)
